import { Injectable } from '@angular/core';
import * as FileSaver from 'file-saver';
import { Borders, Cell, Fill, Workbook, Worksheet } from 'exceljs';
import { HttpClient } from '@angular/common/http';
const EXCEL_TYPE = 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet; charset=UTF-8';
const EXCEL_EXT = '.xlsx';
import { LocalStorageService } from '../../../shared/services/loca-storage.service';

@Injectable()
export class ExportService {

  readonly FULL_BORDER : Partial<Borders> = { top : {style : 'thin'}, right : {style : 'thin'}, bottom : {style : 'thin'}, left : {style : 'thin'} }
  readonly BACKGROUND_SECTION : Fill = { type: 'pattern',
                                          pattern: 'solid',
                                          fgColor: { argb: 'f5b914' }
                                        };

  readonly BACKGROUND_TITLE_GRID  : Fill = { type: 'pattern',
                                        pattern: 'solid',
                                        fgColor: { argb: '92D050' }
                                      };

  urlLogo: string;
  user: any;

  constructor(private http: HttpClient,
    private storageService: LocalStorageService) { 
      this.storageService.get('auth_user').then((user: any) => {
        this.user = user;
        this.urlLogo = this.user.urlLogo;
      }).catch((e) => {
        console.log('constructor->ExportService', e);
      });
    }

  async exportToExcelDOEQ(json: any[], excelFileName: string, tittle: string, params?: any[]) {
    let imageB64;
    if (this.urlLogo) {
      imageB64 = await new Promise((resolve, reject) => {
        this.http.get(this.urlLogo, { responseType: 'blob' })
          .subscribe(blob => {
            const reader = new FileReader();
            reader.readAsDataURL(blob);
            reader.onload = (event: any) => {
              resolve(event.target.result);
            };
            reader.onerror = (event: any) => {
              reject(null);
              console.log("File could not be read: " + event.target.error.code);
            };
          });
      });
    }

    let workbook = new Workbook();
    let worksheet = workbook.addWorksheet('Reporte');
    if (this.urlLogo) {
      let logo = workbook.addImage({
        base64: imageB64.toString(),
        extension: 'png',
      });
  
      // worksheet.mergeCells('A1:D5');
      worksheet.addImage(logo, 'A1:D5');
    }

    /* Configuracion titulo */
    // worksheet.mergeCells('F2:O2');
    let cellTittle = worksheet.getCell('G2');
    cellTittle.font = { name: 'Calibri', family: 4, size: 18, bold: true };
    cellTittle.value = tittle;
    cellTittle.alignment = { wrapText: false };

    worksheet.getCell('G3').value = 'Fecha Impresión:';

    let dateNow = new Date();
    worksheet.getCell('H3').value = `${dateNow.getDate()}/${dateNow.getMonth() + 1}/${dateNow.getFullYear()}`;

    /* Parametros */

    if (params) {
      //worksheet.addRow(['Parametros']);
      worksheet.getCell('A6');
      //cellParams.font = { bold: true };

      let iniCell: number = 7;
      params.forEach(param => {
        worksheet.addRow([`${param.name}:`, param.value]);
        worksheet.getCell(`A${iniCell}`).font = { bold: true };
        iniCell++;
      });
    }
    worksheet.addRow([]);
    /* DATA */
    let header = Object.keys(json[0]);
    let data = json.map(Object.values);
    worksheet.addRow(header).font = { bold: true };
    worksheet.addRows(data);
    worksheet.mergeCells('AK13:AQ13');
    worksheet.mergeCells('A13:AJ13');
    worksheet.getCell('AK13').font = { bold: true };
    worksheet.getCell('AK13').value = 'PAGOS Y RECHAZOS - TESORERÍA';
    worksheet.getCell('AK13').alignment = { vertical: 'middle', horizontal: 'center' };
    worksheet.getCell('AK13').border = {
      top: {style:'thin'},
      left: {style:'thin'},
      bottom: {style:'thin'},
      right: {style:'thin'}
    };
    worksheet.getCell('A13').border = {
      top: {style:'thin'},
      left: {style:'thin'},
      bottom: {style:'thin'},
      right: {style:'thin'}
    };

    workbook.xlsx.writeBuffer().then((data) => {
      this.saveExcel(data, excelFileName);
    })
  }

  async exportToExcel(json: any[], excelFileName: string, tittle: string, params?: any[]) {
    let imageB64;
    if (this.urlLogo) {
      imageB64 = await new Promise((resolve, reject) => {
        this.http.get(this.urlLogo, { responseType: 'blob' })
          .subscribe(blob => {
            const reader = new FileReader();
            reader.readAsDataURL(blob);
            reader.onload = (event: any) => {
              resolve(event.target.result);
            };
            reader.onerror = (event: any) => {
              reject(null);
              console.log("File could not be read: " + event.target.error.code);
            };
          });
      });
    }

    let workbook = new Workbook();
    let worksheet = workbook.addWorksheet('Reporte');
    if (this.urlLogo) {
      let logo = workbook.addImage({
        base64: imageB64.toString(),
        extension: 'png',
      });
  
      // worksheet.mergeCells('A1:D5');
      worksheet.addImage(logo, 'A1:D5');
    }

    /* Configuracion titulo */
    // worksheet.mergeCells('F2:O2');
    let cellTittle = worksheet.getCell('G2');
    cellTittle.font = { name: 'Calibri', family: 4, size: 18, bold: true };
    cellTittle.value = tittle;
    cellTittle.alignment = { wrapText: false };

    worksheet.getCell('G3').value = 'Fecha Impresión:';

    let dateNow = new Date();
    worksheet.getCell('H3').value = `${dateNow.getDate()}/${dateNow.getMonth() + 1}/${dateNow.getFullYear()}`;

    /* Parametros */

    if (params) {
      //worksheet.addRow(['Parametros']);
      worksheet.getCell('A6');
      //cellParams.font = { bold: true };

      let iniCell: number = 7;
      params.forEach(param => {
        worksheet.addRow([`${param.name}:`, param.value]);
        worksheet.getCell(`A${iniCell}`).font = { bold: true };
        iniCell++;
      });
    }
    worksheet.addRow([]);
    /* DATA */

    let header = Object.keys(json[0]);
    let data = json.map(Object.values);
    worksheet.addRow(header).font = { bold: true };
    worksheet.addRows(data);

    workbook.xlsx.writeBuffer().then((data) => {
      this.saveExcel(data, excelFileName);
    })
  }

  private saveExcel(buffer: any, fileName: string): void {
    const data: Blob = new Blob([buffer], { type: EXCEL_TYPE });
    FileSaver.saveAs(data, `${fileName}_${new Date().getTime()}${EXCEL_EXT}`);
  }

  async exportToFile(data: any[], fileName: string, ext: string, typeFile: string, separator : string = ',') {
    const replacer = (key, value) => value === null ? '' : value;
    const header = Object.keys(data[0]);
    let csv = data.map(row => header.map(field => row[field]).join(separator));
    csv.unshift(header.join(separator));
    let csvArray = csv.join('\r\n');

    //var blob = new Blob([csvArray], { type: typeFile })
    const BOM = '\uFEFF'; // Use this and utf8 to support hebrew
    const blob = new Blob([BOM + csvArray], {
      type: 'data:text/csv;charset=utf-8'
    });
    FileSaver.saveAs(blob, `${fileName}_${new Date().getTime()}${ext}`);
  }

  async exportReportAsset(data, company_info : any = null, fields_location_report : any = null){
    let imageB64;

    if (!company_info){
      company_info = {
        "campany" : "UNIVERSIDAD DEL BOSQUE",
        "nit" : "860066789-6",
        "resolucion": "Resolución Ministerio de Educación No. 327 de febrero de 1997"
      };
    }
    //se carga el log
    if (this.urlLogo) {
      imageB64 = await new Promise((resolve, reject) => {
        this.http.get(this.urlLogo, { responseType: 'blob' })
          .subscribe(blob => {
            const reader = new FileReader();
            reader.readAsDataURL(blob);
            reader.onload = (event: any) => {
              resolve(event.target.result);
            };
            reader.onerror = (event: any) => {
              reject(null);
              console.log("File could not be read: " + event.target.error.code);
            };
          });
      });
    }

    //se crea el excel
    let workbook = new Workbook();
    let worksheet = workbook.addWorksheet('Reporte');

    // se adiciona el logo al excel
    if (this.urlLogo) {
      let logo = workbook.addImage({
        base64: imageB64.toString(),
        extension: 'png',
      });
  
      worksheet.addImage(logo, 'A1:D5');
    }

    worksheet.mergeCells('F2:H2')
    let current_cell =worksheet.getCell('F2');

    //se adiciona el encabezado del excel
    current_cell.font = { name: 'Calibri', family: 4, size: 18, bold: true };
    current_cell.value = 'HOJA DE VIDA ACTIVOS FIJOS';

    worksheet.mergeCells('F3:H3');
    current_cell = worksheet.getCell('F3');
    current_cell.value = company_info.campany;

    worksheet.mergeCells('F4:H4');
    current_cell = worksheet.getCell('F4');
    current_cell.value = company_info.nit;

    worksheet.mergeCells('F5:H5');
    current_cell = worksheet.getCell('F5');
    current_cell.value = company_info.resolucion;

    worksheet.mergeCells('F6:H6');
    current_cell = worksheet.getCell('F6');
    current_cell.value = 'Vigilada Mineducación';

    worksheet.mergeCells('A8:L8')
    current_cell = worksheet.getCell('A8');
    current_cell.value = '1. IDENTIFICACIÓN ACTIVO:';
    current_cell.font = {size : 14, bold : true};
    current_cell.fill =  this.BACKGROUND_SECTION;
    current_cell.border = this.FULL_BORDER;
    

    //se pinta la identificacion del activo 
    this.print_asset_identication(data, worksheet);

    
    worksheet.mergeCells('A28:L28');
    current_cell = worksheet.getCell('A28');
    current_cell.value = '2. UBICACIÓN ACTIVOS Y RESPONSABLES:';
    current_cell.font = {size : 14, bold : true};
    current_cell.fill =  this.BACKGROUND_SECTION;
    current_cell.border = this.FULL_BORDER;

    //se pinta la ubicación y responssables
    let row_ref = data.localizaciones ?  this.print_location(data.localizaciones, worksheet, fields_location_report) : 28;

    row_ref ++;
    worksheet.mergeCells(`A${row_ref}:L${row_ref}`);
    current_cell = worksheet.getCell(`A${row_ref}:L${row_ref}`);
    current_cell.value = '3. INFORMACIÓN COMPRA:';
    current_cell.font = {size : 14, bold : true};
    current_cell.fill =  this.BACKGROUND_SECTION;
    current_cell.border = this.FULL_BORDER;

    row_ref = data.compras ? this.print_purchase(data.compras, row_ref, worksheet) : row_ref++;

    row_ref++;
    worksheet.mergeCells(`A${row_ref}:L${row_ref}`)
    current_cell = worksheet.getCell(`A${row_ref}:L${row_ref}`);
    current_cell.value = '4. REGISTRO INSTALACIÓN ACTIVO Y CAPACITACIÓN :';
    current_cell.font = {size : 14, bold : true};
    current_cell.fill =  this.BACKGROUND_SECTION;
    current_cell.border = this.FULL_BORDER;

    row_ref++;

    if(data.instalacion && data.instalacion.length ){
      row_ref = this.print_facility(data.instalacion[0], row_ref, worksheet);
    }

    row_ref+=2;
    worksheet.mergeCells(`A${row_ref}:L${row_ref}`)
    current_cell = worksheet.getCell(`A${row_ref}:L${row_ref}`);
    current_cell.value = '5. REGISTRO HISTORICO MANTENIMIENTO :';
    current_cell.font = {size : 14, bold : true};
    current_cell.fill =  this.BACKGROUND_SECTION;
    current_cell.border = this.FULL_BORDER

    row_ref = data.mantenimiento ? this.print_maintenance(data.mantenimiento, row_ref, worksheet) : row_ref ++;


    //se realiza  el guardado
    workbook.xlsx.writeBuffer().then(
      data => { this.saveExcel(data, 'HOJA_DE_VIDA_ACTIVO')}
    )
  }

  public print_asset_identication(data, worksheet : Worksheet){

    let list_labels = [{label : "FECHA DE PUESTA EN SERVICIO", cell : "A10"},
    {label : "ESTADO", cell : "A12"},
    {label : "TIPO DE ACTIVO", cell : "A14"},
    {label : "ID ACTIVO", cell : "A16"},
    {label : "DESCRIPCIÓN", cell : "A18"},
    {label : "CATEGORÍA", cell : "A20"},
    {label : "ORIGEN", cell : "A22"},
    {label : "CENTRO DE COSTO", cell : "A24"},
    {label : "PROYECTO", cell : "A26"},
    {label : "MARCA", cell : "E10"},
    {label : "SERIE", cell : "E12"},
    {label : "MODELO", cell : "E14"},
    {label : "REFERENCIA", cell : "E16"},
    {label : "FABRICANTE", cell : "E18"},
    {label : "VIDA UTIL FABRICANTE", cell : "E20"},
    {label : "REGISTRO SANITARIO", cell : "H10"},
    {label : "PESO", cell : "H12"},
    {label : "TEMPERATURA", cell : "H14"},
    {label : "CLASIFICACIÓN ENERGETICA", cell : "H16"},
    {label : "ANCHO", cell : "H20"},
    {label : "ALTO", cell : "H22"},
    {label : "LARGO", cell : "H24"},
    {label : "INVENTARIO FISICO", cell : "G26"},
    {label : "FECHA INICIO GARANTIA", cell : "E22"},
    {label : "FECHA FIN GARANTIA", cell : "E24"}];

    let list_values = [ { key : "marca", cell : 'F10'},
    {key : "serie", cell: 'F12'},
    {key : "modelo", cell: 'F14'},
    {key : "proyecto", cell : 'C26'},
    {key : "categoria", cell : 'C20'},
    {key : "id_activo", cell : 'C16'},
    {key : "referencia", cell : 'F16'},
    {key : "descripcion", cell : 'C18'},    
    {key : "tipo_activo", cell : 'C14'},
    {key : "centro_costo", cell: 'C24'},
    {key : "purchase_date_guarantee_fin", cell : 'F22'},
    {key : "purchase_date_guarantee_ini", cell : 'F24'},
    {key : "alto", cell : 'I22'},
    {key : "peso", cell : 'I12'},
    {key : "ancho", cell : 'I20'},
    {key : "largo", cell : 'I24'},
    {key : "inventario_fisico", cell : 'I26'},
    {key : "marca", cell :'F10'},
    {key : "estado", cell :'C12'},
    {key : "origen", cell :'C22'},
    {key : "fabricante", cell :'F18'},
    {key : "temperatura", cell :'I14'},
    {key : "registro_sanitario", cell :'I10'},
    {key : "vida_util_fabricante", cell :'F20'},
    {key : "clasificacion_energetica", cell :'I16'},
    {key : "fecha_de_puesta_en_servicio", cell :'C10'},
  
  ]

    let current_cell : Cell ;

    list_labels.forEach(item =>{
      current_cell = worksheet.getCell(item.cell);
      current_cell.value = item.label;

    });

    
    list_values.forEach(item => {
      current_cell = worksheet.getCell(item.cell);      
      current_cell.value = data[item.key];
      current_cell.border= this.FULL_BORDER;

    })

  }

  public print_location(data : any[], worksheet : Worksheet, fields_location_report : any = null){
    let list_labels = [{ label : "FECHA", cell : "A30"},
    { label : "CIUDAD", cell : "B30"},
    { label : "INSTALACION", cell : "C30"},
    { label : "SITIO", cell : "D30"},
    { label : "PISO", cell : "E30"},
    { label : "AREA", cell : "F30"},
    { label : "NUMERO DE EMPLEADO", cell : "G30"},
    { label : "NOMBRE EMPLEADO", cell : "H30"},
    { label : "NUMERO DE EMPLEADO 2", cell : "I30"},
    { label : "NOMBRE DE EMPLEADO 2", cell : "J30"},
    { label : "CENTRO COSTO", cell : "K30:L30"},
  ];

    let list_values = [
      { key : "fecha", cell : 'A'},
      { key : "ciudad", cell : 'B'},
      { key : "instalacion", cell : 'C'},
      { key : "sitio", cell : 'D'},
      { key : "piso", cell : 'E'},
      { key : "area", cell : 'F'},
      { key : "numero_de_empleado_1", cell : 'G'},
      { key : "nombre_de_empleado_1", cell : 'H'},
      { key : "numero_de_empleado_2", cell : 'I'},
      { key : "nombre_de_empleado_2", cell : 'J'},
      { key : "centro_costo", cell : 'K'},
  ];

  if (fields_location_report){
    list_labels = fields_location_report.list_labels;
    list_values = fields_location_report.list_values;
  }

    let current_cell : Cell ;
    let current_row = 31;
    list_labels.forEach(item => {

      if (item.label == "CENTRO COSTO"){
        worksheet.mergeCells(item.cell);
      }

      current_cell = worksheet.getCell(item.cell);
      current_cell.value = item.label;
      current_cell.font = {bold : true};
      current_cell.border = this.FULL_BORDER;
      current_cell.fill = this.BACKGROUND_TITLE_GRID;

    });

    data.forEach( row_loc => {
      list_values.forEach(item =>{

        if(item.key == "centro_costo"){
          worksheet.mergeCells(`K${current_row}:L${current_row}`);

        }

        current_cell = worksheet.getCell(item.cell + current_row);
        current_cell.value = row_loc[item.key];
        current_cell.border = this.FULL_BORDER;

      });
      current_row ++;
    });


    return current_row;
  }

  print_purchase(data : any[], row_ref : number, worksheet : Worksheet){

    row_ref ++;
    worksheet.mergeCells(`A${row_ref}:C${row_ref}`);
    let current_cell = worksheet.getCell(`A${row_ref}:C${row_ref}`);
    current_cell.value = 'Fecha compra';
    current_cell.font = {bold : true};
    current_cell.border = this.FULL_BORDER;
    current_cell.fill = this.BACKGROUND_TITLE_GRID;


    worksheet.mergeCells(`D${row_ref}:F${row_ref}`);
    current_cell = worksheet.getCell(`D${row_ref}:F${row_ref}`);
    current_cell.value = 'Proveedor';
    current_cell.font = {bold : true};
    current_cell.border = this.FULL_BORDER;
    current_cell.fill = this.BACKGROUND_TITLE_GRID;

    worksheet.mergeCells(`G${row_ref}:I${row_ref}`);
    current_cell = worksheet.getCell(`G${row_ref}:I${row_ref}`);
    current_cell.value = 'No. Orden de compra';
    current_cell.font = {bold : true};
    current_cell.border = this.FULL_BORDER;
    current_cell.fill = this.BACKGROUND_TITLE_GRID;

    worksheet.mergeCells(`J${row_ref}:L${row_ref}`);
    current_cell = worksheet.getCell(`J${row_ref}:L${row_ref}`);
    current_cell.value = 'No. Factura';
    current_cell.font = {bold : true};
    current_cell.border = this.FULL_BORDER;
    current_cell.fill = this.BACKGROUND_TITLE_GRID;

    row_ref ++;

    data.forEach(item => {
      worksheet.mergeCells(`A${row_ref}:C${row_ref}`);
      current_cell = worksheet.getCell(`A${row_ref}:C${row_ref}`);
      current_cell.value = item.fecha_compra;
      current_cell.border = this.FULL_BORDER;

      worksheet.mergeCells(`D${row_ref}:F${row_ref}`);
      current_cell = worksheet.getCell(`D${row_ref}:F${row_ref}`);
      current_cell.value = item.proveedor;
      current_cell.border = this.FULL_BORDER;

      worksheet.mergeCells(`G${row_ref}:I${row_ref}`);
      current_cell = worksheet.getCell(`G${row_ref}:I${row_ref}`);
      current_cell.value = item.orden_de_compra;
      current_cell.border = this.FULL_BORDER;

      worksheet.mergeCells(`J${row_ref}:L${row_ref}`);
      current_cell = worksheet.getCell(`J${row_ref}:L${row_ref}`);
      current_cell.value = item.numero_factura;
      current_cell.border = this.FULL_BORDER;

      row_ref++
    });

    return row_ref;

  }

  public print_facility(data, row_ref : number, worksheet: Worksheet){
    row_ref ++;
    worksheet.mergeCells(`A${row_ref}:C${row_ref}`);
    let current_cell = worksheet.getCell(`A${row_ref}`);
    current_cell.value = 'ACTIVO INSTALADO POR EL PROVEEDOR : ';

    current_cell = worksheet.getCell(`D${row_ref}`);
    current_cell.value = data.instalado_por_proveedor == '1' ? 'SI' : 'NO';
    current_cell.border = this.FULL_BORDER;

    current_cell = worksheet.getCell(`F${row_ref}`);
    current_cell.value = 'NOMBRE DEL PROVEEDOR';

    current_cell = worksheet.getCell(`G${row_ref}`);
    current_cell.value = data.nombre_proveedor;
    current_cell.border = this.FULL_BORDER;

    current_cell = worksheet.getCell(`I${row_ref}`);
    current_cell.value = 'INSTALADO POR';

    current_cell = worksheet.getCell(`J${row_ref}`);
    current_cell.value = data.instalado_por;
    current_cell.border = this.FULL_BORDER;

    row_ref += 2;
    worksheet.mergeCells(`A${row_ref}:C${row_ref}`);
    current_cell = worksheet.getCell(`A${row_ref}`);
    current_cell.value = 'INSTALACION APROBADO POR';

    current_cell = worksheet.getCell(`D${row_ref}`);
    current_cell.value = data.instalacion_aprobada_por;
    current_cell.border = this.FULL_BORDER;

    current_cell = worksheet.getCell(`F${row_ref}`);
    current_cell.value = 'PERIOCIDAD DE MANTENIMIENTO';

    current_cell = worksheet.getCell(`G${row_ref}`);
    current_cell.value = data.periodicidad_mantenimiento;
    current_cell.border = this.FULL_BORDER;

    row_ref += 2;

    
    current_cell = worksheet.getCell(`A${row_ref}`);
    current_cell.value = 'FECHA';
    current_cell.border = this.FULL_BORDER;
    current_cell.font = {bold : true};
    current_cell.fill = this.BACKGROUND_TITLE_GRID;

    worksheet.mergeCells(`B${row_ref}:F${row_ref}`);
    current_cell = worksheet.getCell(`B${row_ref}`);
    current_cell.value = 'MATERIALES UTILIZADOS';
    current_cell.border = this.FULL_BORDER;
    current_cell.font = {bold : true};
    current_cell.fill = this.BACKGROUND_TITLE_GRID;

    worksheet.mergeCells(`G${row_ref}:L${row_ref}`);
    current_cell = worksheet.getCell(`G${row_ref}`);
    current_cell.value = 'DESCRIPCIÓN';
    current_cell.border = this.FULL_BORDER;
    current_cell.font = {bold : true};
    current_cell.fill = this.BACKGROUND_TITLE_GRID;

    row_ref ++;
    if(data.detalle_materiales){
      data.detalle_materiales.forEach(element => {

        current_cell = worksheet.getCell(`A${row_ref}`);
        current_cell.value = element.fecha;
        current_cell.border = this.FULL_BORDER;

        worksheet.mergeCells(`B${row_ref}:F${row_ref}`);
        current_cell = worksheet.getCell(`B${row_ref}`);
        current_cell.value = element.materiales_utilizados;
        current_cell.border = this.FULL_BORDER;

        worksheet.mergeCells(`G${row_ref}:L${row_ref}`);
        current_cell = worksheet.getCell(`G${row_ref}`);
        current_cell.value = element.descripcion;
        current_cell.border = this.FULL_BORDER;

        row_ref ++;
      });
    }

    row_ref ++;

    worksheet.mergeCells(`A${row_ref}:C${row_ref}`);
    current_cell = worksheet.getCell(`A${row_ref}`);
    current_cell.value = 'CAPAICATION Y MANEJO DEL ACTIVO';

    current_cell = worksheet.getCell(`D${row_ref}`);
    current_cell.value = data.capacitacion_manejo_activo == '1' ? 'SI' : 'NO';
    current_cell.border = this.FULL_BORDER;

    current_cell = worksheet.getCell(`F${row_ref}`);
    current_cell.value = 'FECHA CAPACITACIÓN';

    current_cell = worksheet.getCell(`G${row_ref}`);
    current_cell.value = data.fecha_capacitacion;
    current_cell.border = this.FULL_BORDER;

    current_cell = worksheet.getCell(`I${row_ref}`);
    current_cell.value = 'HORAS CAPACITACIÓN';

    current_cell = worksheet.getCell(`J${row_ref}`);
    current_cell.value = data.horas_capacitacion;
    current_cell.border = this.FULL_BORDER;

    row_ref += 2;

    worksheet.mergeCells(`A${row_ref}:L${row_ref}`);
    current_cell = worksheet.getCell(`A${row_ref}`);
    current_cell.border = this.FULL_BORDER;
    current_cell.font = {bold : true};
    current_cell.fill = this.BACKGROUND_TITLE_GRID;
    current_cell.value = 'PERSONAL CAPACITADO';

    row_ref ++;   

    worksheet.mergeCells(`A${row_ref}:C${row_ref}`);
    current_cell = worksheet.getCell(`A${row_ref}`);
    current_cell.border = this.FULL_BORDER;
    current_cell.font = {bold : true};
    current_cell.fill = this.BACKGROUND_TITLE_GRID;
    current_cell.value = 'NÚMERO EMPLEADO.' 

    worksheet.mergeCells(`D${row_ref}:L${row_ref}`);
    current_cell = worksheet.getCell(`D${row_ref}`);
    current_cell.border = this.FULL_BORDER;
    current_cell.font = {bold : true};
    current_cell.fill = this.BACKGROUND_TITLE_GRID;
    current_cell.value = 'NOMBRE EMPLEADO.';

    let trained_staff = data.personal_capacitado ? data.personal_capacitado :  [];
    row_ref ++;
    
    trained_staff.forEach(element => {

      worksheet.mergeCells(`A${row_ref}:C${row_ref}`);
      current_cell = worksheet.getCell(`A${row_ref}`);
      current_cell.border = this.FULL_BORDER;
      current_cell.value = element.number_employee 

      worksheet.mergeCells(`D${row_ref}:L${row_ref}`);
      current_cell = worksheet.getCell(`D${row_ref}`);
      current_cell.border = this.FULL_BORDER;
      current_cell.value = element.name_employee;
      row_ref ++;
      
    });

    return row_ref;

  }

  public print_maintenance( data : any[], row_ref : number, worksheet : Worksheet){

    row_ref ++;
    let current_cell = worksheet.getCell(`A${row_ref}`);
    current_cell.value = "Tipo de mantenimiento";
    current_cell.border = this.FULL_BORDER;
    current_cell.font = {bold : true}
    current_cell.fill = this.BACKGROUND_TITLE_GRID;

    current_cell = worksheet.getCell(`B${row_ref}`);
    current_cell.value = "Fecha" ;
    current_cell.border = this.FULL_BORDER;
    current_cell.font = {bold : true}
    current_cell.fill = this.BACKGROUND_TITLE_GRID;

    current_cell = worksheet.getCell(`C${row_ref}`);
    current_cell.value = "Proveedor";
    current_cell.border = this.FULL_BORDER;
    current_cell.font = {bold : true}
    current_cell.fill = this.BACKGROUND_TITLE_GRID;

    current_cell = worksheet.getCell(`D${row_ref}`);
    current_cell.value = "No. orden de compra";
    current_cell.border = this.FULL_BORDER;
    current_cell.font = {bold : true}
    current_cell.fill = this.BACKGROUND_TITLE_GRID;

    current_cell = worksheet.getCell(`E${row_ref}`);
    current_cell.value = "Repuestos utilizados" ;
    current_cell.border = this.FULL_BORDER;
    current_cell.font = {bold : true}
    current_cell.fill = this.BACKGROUND_TITLE_GRID;

    current_cell = worksheet.getCell(`F${row_ref}`);
    current_cell.value = "Descripción del mantenimiento";
    current_cell.border = this.FULL_BORDER;
    current_cell.font = {bold : true}
    current_cell.fill = this.BACKGROUND_TITLE_GRID;

    current_cell = worksheet.getCell(`G${row_ref}`);
    current_cell.value = "Garantia del mantenimiento";
    current_cell.border = this.FULL_BORDER;
    current_cell.font = {bold : true}
    current_cell.fill = this.BACKGROUND_TITLE_GRID;

    current_cell = worksheet.getCell(`H${row_ref}`);
    current_cell.value =  "Mantenimiento aceptado por";
    current_cell.border = this.FULL_BORDER;
    current_cell.font = {bold : true}
    current_cell.fill = this.BACKGROUND_TITLE_GRID;

    worksheet.mergeCells(`I${row_ref}:L${row_ref}`);
    current_cell = worksheet.getCell(`I${row_ref}`);
    current_cell.value = "Costo de mantenimiento";
    current_cell.border = this.FULL_BORDER;
    current_cell.font = {bold : true}
    current_cell.fill = this.BACKGROUND_TITLE_GRID;

    let list_keys = [
      {key : "tipo_de_mantenimiento", col : "A"},
      {key : "fecha", col : "B"},
      {key : "proveedor", col : "C"},
      {key : "numero_orden_de_compra", col : "D"},
      {key : "repuestos_utilizados", col : "E"},
      {key : "descripcion_mantenimiento", col : "F"},
      {key : "garantia_mantemiento", col : "G"},
      {key : "mantenimiento_aceptado_por", col : "H"},
      {key : "costo_de_mantenimiento", col : "I"},];

    row_ref ++;
    data.forEach(row =>{
      list_keys.forEach(item =>{

        if (item.key == 'costo_de_mantenimiento'){
          worksheet.mergeCells(`I${row_ref}:L${row_ref}`);
        }

        current_cell = worksheet.getCell(item.col+row_ref);
        current_cell.value = row[item.key];
        current_cell.border = this.FULL_BORDER;
      });
      row_ref ++;
    });

    return row_ref;

  }

  async saveFile(buffer: any, fileName: string, type: string) {
    const base64 = await fetch(`data:${type};base64,${buffer}`);
    const blob = await base64.blob();
    FileSaver.saveAs(blob, `${fileName}`);
  }

}



// WEBPACK FOOTER //
// ./src/app/core/services/export/export.service.ts